import { z } from "zod";
export const UserCRMMetadataSchema = z.object({}).passthrough().partial();
